import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

function KButton(props: any) {
  const button = (
    <Button
      id={props.id}
      type={!!props.type ? props.type : 'button'}
      size={!!props.size ? props.size : 'sm'}
      className={`py-1 ${props.className ?? ''}`.trim()}
      variant={!!props.variant ? props.variant : 'secondary'}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {!!props.icon && <i className={'bi bi-' + props.icon} style={{ fontSize: '14px' }}></i>}
      {!!props.label && (
        <>
          {!!props.icon && <>&nbsp;&nbsp;</>}
          <span
            className='align-top'
            style={{ fontSize: '15px', textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            <b>{props.label}</b>
          </span>
        </>
      )}
    </Button>
  )

  const triggerElement = props.disabled ? <span>{button}</span> : button

  return (
    <>
      {!!props.title ? (
        <OverlayTrigger overlay={<Tooltip>{props.title}</Tooltip>}>{triggerElement}</OverlayTrigger>
      ) : (
        triggerElement
      )}
    </>
  )
}

export default KButton
